import { useState, useEffect } from "react";
import "./Representantes.css";
import Imagens from "../../../components/IMAGESCOMPONENT/ImageComponent";
import Navbar from "../../../components/parts/navbar/Navbar";
import TopLinks from "../../../components/parts/TopLinks/TopLinks";
import Menu from "../../../components/parts/menu/Menu";
import Footer from "../../../components/parts/footer/Footer";
import RepresentanteBanners from "./representantebanner/RepresentanteBanners";
import Section from "../../../components/debug/Section";
import BTNtoTop from "../../../components/parts/BTNtoTop/BTNtoTop";
import RepresentanteInfo from "./representanteinfo/RepresentanteInfo";
import RepresentanteText from "./representanteText/RepresentanteText";

export default function Representantes() {
  const [menuOpen, setMenuOpen] = useState(false);

  // 🔹 Banners
  const [banners, setBanners] = useState([]);
  const [loadingBanners, setLoadingBanners] = useState(true);

  // 🔹 Descricao
  const [descricao, setDescricao] = useState([]);
  const [loadingDescricao, setLoadingDescricao] = useState(true);

  const [titulos, setTitulos] = useState([]);
  const [loadingTitulos, setLoadingTitulos] = useState(true);

  // 🔹 Carregar banners

  useEffect(() => {
    async function carregarBanners() {
      try {
        const response = await fetch(
          "https://app.eliandroalimentos.com.br/api/home_media/listar",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
          }
        );
        const data = await response.json();
        setBanners(data);
      } catch (error) {
        console.error("Erro ao buscar títulos:", error);
      } finally {
        setLoadingBanners(false);
      }
    }

    carregarBanners();
  }, []);

  // 🔹 Carregar Descricao
  useEffect(() => {
    async function carregarDescricao() {
      try {
        const response = await fetch(
          "https://app.eliandroalimentos.com.br/api/desc/listar",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
          }
        );
        const data = await response.json();
        setDescricao(data);
      } catch (error) {
        console.error("Erro ao buscar produtos:", error);
      } finally {
        setLoadingDescricao(false);
      }
    }

    carregarDescricao();
  }, []);

  //Carregar Titulos
  useEffect(() => {
    async function carregarTitulos() {
      try {
        const response = await fetch(
          "https://app.eliandroalimentos.com.br/api/titulos/listar",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
          }
        );

        const data = await response.json();
        console.log("res", data);
        setTitulos(data);
      } catch (error) {
        console.error("Erro ao buscar títulos:", error);
      } finally {
        setLoadingTitulos(false);
      }
    }

    carregarTitulos();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <>
      <Navbar />
      <TopLinks onOpenMenu={() => setMenuOpen(true)} />
      <Menu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />

      <Section name="RepresentanteBanners 1">
        <RepresentanteBanners 
          banners={banners}
          localizacao={"representante1"}
        />
      </Section>

      {/* CONTEÚDO */}
      <section className="representantes-content">
        <div className="content-wrapper">
          <Section name="Representante lateral">
            <RepresentanteBanners
              banners={banners}
              localizacao={"representantelateral"}
            />
          </Section>

          <Section name="RepresentanteInfo">
            <RepresentanteInfo
              descricao={descricao}
              localizacao={"representantetexto"}
              titulo={titulos}
            />
          </Section>
        </div>
      </section>

      <Section name="RepresentanteBanners MiniBanner">
        <RepresentanteBanners
          banners={banners}
          localizacao={"representanteminibanner"}
        />
      </Section>

      <div className="colum">
        <Section name="Representante Text">
          <RepresentanteText
            titulos={titulos}
            localizacao="representantedesc"
          />
        </Section>

        <Section name="RepresentanteBanners 2">
          <RepresentanteBanners 
            banners={banners}
            localizacao={"representante2"}
          />
        </Section>
      </div>

      <BTNtoTop />
      <Footer />
    </>
  );
}
